import api from "../util/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { BuscarRateioCentroCustoModel } from "../models/rateioCentroCusto/buscarRateioCentroCustoModel";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import { toastError, toastSucess } from "../util/toast";
import { setModalDeletarRateioCentroCusto, setPageRateioCentroCusto } from "../redux/slices/rateioCentroCusto/rateioCentroCustoSlice";

export const cadastrarRateioCentroCusto = createAsyncThunk("/RateioCentroCusto/CadastrarRateioCentroCusto", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/RateioCentroCusto/CadastrarRateioCentroCusto", payload.value);
    toastSucess("Rateio cadastrado com sucesso");
    dispatch(setPageRateioCentroCusto("geral"));
    dispatch(setLoading(false));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const buscarRateioCentroCusto = createAsyncThunk("/RateioCentroCusto/BuscarRateioCentroCusto", async (args: BuscarRateioCentroCustoModel) => {
  try {
    const data = await api.get("/RateioCentroCusto/BuscarRateioCentroCusto", {
      params: args,
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const atualizarRateioCentroCusto = createAsyncThunk("/RateioCentroCusto/AtualizarRateioCentroCusto", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/RateioCentroCusto/AtualizarRateioCentroCusto/", payload.value);
    toastSucess("Rateio atualizado com sucesso");
    dispatch(setPageRateioCentroCusto("geral"));
    dispatch(setLoading(false));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const atualizarRateioCentroCustoAtivo = createAsyncThunk("/RateioCentroCusto/AtualizarRateioCentroCustoAtivo", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/RateioCentroCusto/AtualizarRateioCentroCustoAtivo", null, {
      params: payload.value,
    });
    toastSucess("Status de ativo do rateio atualizado com sucesso");
    dispatch(setLoading(false));

    dispatch(buscarRateioCentroCusto(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const deletarRateioCentroCusto = createAsyncThunk("/RateioCentroCusto/DeletarRateioCentroCusto", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.delete("/RateioCentroCusto/DeletarRateioCentroCusto/?id=" + payload.value);
    toastSucess("Rateio removido com sucesso");
    dispatch(setModalDeletarRateioCentroCusto(false));
    dispatch(setLoading(false));

    dispatch(buscarRateioCentroCusto(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});
